import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import {Button} from '../../../../../../components/UI/Button'
import {InputDate} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {availabilitySchema} from '../../../../../../util/validationHoteleria'
import {ClientModel, CompanyModel} from '../../../../../central/model'
import {getClient, getCompany} from '../../../../../central/services'
import {useBed} from '../../../../hooks/useBed'
import {useModules} from '../../../../hooks/useModules'
import {useRooms} from '../../../../hooks/useRooms'
import {AvailabilityModel} from '../../../../models/availability.model'
import {CampModel, SiteModel} from '../../../modules/models'
import {getCampsService, getSitesService} from '../../../modules/services'
import {TableAvailabilityWrapper} from '../Tables/TableAvailability'

interface SelectOption {
  value: string | number | undefined | boolean
  label: string | undefined
}

const FormAvailability: FC = () => {
  const [company, setCompany] = useState<CompanyModel[] | any>([])
  const [client, setClient] = useState<ClientModel[] | any>([])
  const [sites, setSites] = useState<SiteModel[] | any>([])
  const [camps, setCamps] = useState<CampModel[] | any>([])
  //MODULE//
  const {getTypeModules, getModules, getGenresModule, getBathroomsTypeModule, getStatusModule} =
    useModules()
  const [typeModule, setTypeModule] = useState<SelectOption[]>([])
  const [modules, setModules] = useState<SelectOption[]>([])
  const [sexModule, setSexModule] = useState<SelectOption[]>([])
  const [brTypeModule, setBrTypeModule] = useState<SelectOption[]>([])
  const [statusModule, setStatusModule] = useState<SelectOption[]>([])

  //ENDMODULE//
  //ROOM//
  const {
    getTypeRooms,
    // getRooms,
    getGenresRooms,
    getLevelsRoom,
    getBathroomsTypeRooms,
    getStatusRoom,
    getSubStatusRoom,
  } = useRooms()
  const [typeRoom, setTypeRoom] = useState<SelectOption[]>([])
  // const [, setRooms] = useState<SelectOption[]>([])
  const [sexRoom, setSexRoom] = useState<SelectOption[]>([])
  const [levelRoom, setLevelRooms] = useState<SelectOption[]>([])
  const [brTypeRoom, setBrTypeRoom] = useState<SelectOption[]>([])
  const [statusRoom, setStatusRoom] = useState<SelectOption[]>([])
  const [subStatusRoom, setSubStatusRoom] = useState<SelectOption[]>([])
  //ENDROOM
  //BED
  const {getTypeBeds, getStatusBed, getSubStatusBed} = useBed()
  const [typeBed, setTypeBed] = useState<SelectOption[]>([])
  const [bed] = useState<SelectOption[]>([])
  const [camaCaliente] = useState<SelectOption[]>([
    // {
    //   value: '',
    //   label: 'TODOS',
    // },
    {value: true, label: 'SI'},
    {value: false, label: 'NO'},
  ])
  const [statusBed, setStatusBed] = useState<SelectOption[]>([])
  const [subStatusBed, setSubStatusBed] = useState<SelectOption[]>([])

  //ENDBED

  const {
    // reset,
    register,
    formState: {errors},
    control,
    setValue,
    setError,
    // watch,
  } = useForm<AvailabilityModel>({
    resolver: yupResolver(availabilitySchema),
    defaultValues: {
      TipoModuloId: '',
      ModuloId: '',
      ModuloSexoId: '',
      ModuloTipoBanioId: '',
      EstadoModuloId: '',
      TipoHabitacionId: '',
      HabitacionId: '',
      HabitacionSexoId: '',
      HabitacionNivelId: '',
      HabitacionTipoBanioId: '',
      EstadoHabitacionId: '',
      SubEstadoHabitacionId: '',
      TipoCamaId: '',
      CamaId: '',
      CamaCaliente: false,
      EstadoCamaId: '',
      SubEstadoCamaId: '',
    },
  })

  useEffect(() => {
    getCompanyList()
    getTypeModulesFn()
    getSexModuleFn()
    getBathroomsTypeModuleFn()
    getStatusModuleFn()
    getTypeRoomsFn()
    getSexRoomFn()
    getBathroomsTypeRoomsFn()
    getLevelsRoomFn()
    getStatusRoomFn()
    getSubStatusRoomFn()
    getTypeBedsFn()
    getStatusBedFn()
    getSubStatusBedFn()
  }, [])

  const getCompanyList = async () => {
    try {
      // await new Promise((resolve) => setTimeout(resolve, 2000))
      let obj: CompanyModel = {
        isCombo: true,
      }
      const response = await getCompany(obj, 1)
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombreEmpresa}))
      setCompany(mappedSites)
    } catch (error) {
      setCompany([])
    }
  }

  const getClientList = async (companyId: string) => {
    try {
      const response = await getClient({companiaId: companyId}, 1)
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      setClient(mappedSites)
    } catch (error) {
      setClient([])
    }
  }

  const getSites = async (clientId: string) => {
    try {
      let obj: SiteModel = {
        clienteId: clientId,
        isCombo: true,
      }
      const response = await getSitesService(obj, 1)
      const data = response.data.data
      const mappedSites = data?.map((site) => ({value: site.id, label: site.nombre}))
      setSites(mappedSites)
    } catch (error) {
      setSites([])
    }
  }

  const getCamps = async (siteId: string) => {
    try {
      let obj: CampModel = {
        id: '',
        nombre: '',
        siteId: siteId,
        clienteId: '',
        companiaId: '',
        site: '',
        nombreCliente: '',
        nombreCompania: '',
      }
      const response = await getCampsService(obj, 1)
      const data = response.data.data
      const mappedCamps = data?.map((camp) => ({value: camp.id, label: camp.nombre}))
      setCamps(mappedCamps)
    } catch (error) {
      setCamps([])
    }
  }

  // MODULE //

  const getTypeModulesFn = async () => {
    const data = await getTypeModules()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setTypeModule(allData)
  }

  const getModulesFn = async (campamentoId: string) => {
    const data = await getModules({CampamentoId: campamentoId})
    setModules(data)
  }

  const getSexModuleFn = async () => {
    const data = await getGenresModule()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setSexModule(allData)
  }

  const getBathroomsTypeModuleFn = async () => {
    const data = await getBathroomsTypeModule()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setBrTypeModule(allData)
  }

  const getStatusModuleFn = async () => {
    const data = await getStatusModule()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setStatusModule(allData)
  }

  // ROOMS

  const getTypeRoomsFn = async () => {
    const data = await getTypeRooms()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setTypeRoom(allData)
  }

  // const getRoomsFn = async (moduleId: string) => {
  //   const data = await getRooms({ModuloId: moduleId})
  //   setRooms(data)
  // }

  const getSexRoomFn = async () => {
    const data = await getGenresRooms()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setSexRoom(allData)
  }

  const getBathroomsTypeRoomsFn = async () => {
    const data = await getBathroomsTypeRooms()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setBrTypeRoom(allData)
  }

  const getLevelsRoomFn = async () => {
    const data = await getLevelsRoom()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setLevelRooms(allData)
  }

  const getStatusRoomFn = async () => {
    const data = await getStatusRoom()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setStatusRoom(allData)
  }

  const getSubStatusRoomFn = async () => {
    const data = await getSubStatusRoom()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setSubStatusRoom(allData)
  }

  //ENDROOM

  const getTypeBedsFn = async () => {
    const data = await getTypeBeds()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setTypeBed(allData)
  }

  // const getBedsFn = async (roomId: string) => {
  //   const data = await getBeds({HabitacionId: roomId})
  //   setBed(data)
  // }

  const getStatusBedFn = async () => {
    const data = await getStatusBed()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setStatusBed(allData)
  }

  const getSubStatusBedFn = async () => {
    const data = await getSubStatusBed()
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setSubStatusBed(allData)
  }

  ///
  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setSites([])
    setValue('CampamentoId', '')
    setCamps([])
    setError('CompaniaId', {})

    getClientList(value)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ClienteId', value)

    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setCamps([])
    setError('ClienteId', {})
    getSites(value)
  }

  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('SiteId', value)

    setValue('CampamentoId', '')

    getCamps(value)

    setError('SiteId', {})
  }

  const handleCampChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CampamentoId', value)
    setError('CampamentoId', {})
    getModulesFn(value)
  }

  return (
    <div className='sdx_form card p-4'>
      <div className='row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Compañia:</label>
          <Select
            control={control}
            name='CompaniaId'
            data={company}
            errors={errors}
            onChangeValue={handleCompanyChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Cliente:</label>
          <Select
            control={control}
            name='ClienteId'
            data={client}
            errors={errors}
            onChangeValue={handleClientChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Site:</label>
          <Select
            control={control}
            name='SiteId'
            data={sites}
            errors={errors}
            onChangeValue={handleSiteChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Campamento:</label>
          <Select
            control={control}
            name='CampamentoId'
            data={camps}
            errors={errors}
            onChangeValue={handleCampChange}
          />
        </div>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Tipo de Módulo:</label>
          <Select
            control={control}
            name='TipoModuloId'
            data={typeModule}
            errors={errors}
            // onChangeValue={handleTypeModuleChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Módulo:</label>
          <Select
            control={control}
            name='ModuloId'
            data={modules}
            errors={errors}
            // onChangeValue={handleTypeModuleChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Sexo:</label>
          <Select
            control={control}
            name='ModuloSexoId'
            data={sexModule}
            errors={errors}
            // onChangeValue={handleTypeModuleChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Tipo de Baño:</label>
          <Select
            control={control}
            name='ModuloTipoBanioId'
            data={brTypeModule}
            errors={errors}
            // onChangeValue={handleTypeModuleChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Estado de Módulo:</label>
          <Select
            control={control}
            name='EstadoModuloId'
            data={statusModule}
            errors={errors}
            // onChangeValue={handleTypeModuleChange}
          />
        </div>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className=''>Tipo de Habitación:</label>
          <Select control={control} name='TipoHabitacionId' data={typeRoom} errors={errors} />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className=''>Habitación:</label>
          <Select control={control} name='HabitacionId' data={[]} errors={errors} />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className=''>Sexo:</label>
          <Select control={control} name='HabitacionSexoId' data={sexRoom} errors={errors} />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className=''>Piso Habitación:</label>
          <Select control={control} name='HabitacionNivelId' data={levelRoom} errors={errors} />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Tipo de Baño:</label>
          <Select
            control={control}
            name='HabitacionTipoBanioId'
            data={brTypeRoom}
            errors={errors}
            // onChangeValue={handleTypeModuleChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Estado de Habitación:</label>
          <Select
            control={control}
            name='EstadoHabitacionId'
            data={statusRoom}
            errors={errors}
            // onChangeValue={handleTypeModuleChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Sub Estado de Habitación:</label>
          <Select
            control={control}
            name='SubEstadoHabitacionId'
            data={subStatusRoom}
            errors={errors}
            // onChangeValue={handleTypeModuleChange}
          />
        </div>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className=''>Tipo de Cama:</label>
          <Select control={control} name='TipoCamaId' data={typeBed} errors={errors} />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className=''>Cama:</label>
          <Select control={control} name='CamaId' data={bed} errors={errors} />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className=''>Cama Caliente:</label>
          <Select control={control} name='CamaCaliente' data={camaCaliente} errors={errors} />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Estado de Cama:</label>
          <Select
            control={control}
            name='EstadoCamaId'
            data={statusBed}
            errors={errors}
            // onChangeValue={handleTypeModuleChange}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Sub Estado de Cama:</label>
          <Select
            control={control}
            name='SubEstadoCamaId'
            data={subStatusBed}
            errors={errors}
            // onChangeValue={handleTypeModuleChange}
          />
        </div>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <label>Fecha Inicio:</label>
          <InputDate
            name='FechaInicio'
            register={register}
            errors={errors}
            // minValue={moment().format('YYYY-MM-DD')}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label>Fecha Fin:</label>
          <InputDate
            name='FechaFin'
            register={register}
            errors={errors}
            // minValue={moment().format('YYYY-MM-DD')}
          />
        </div>
        <div className='col-sm-12 col-lg-3 d-flex justify-content-center align-items-end pb-2'>
          <Button
            typeBtn='submit'
            label='Buscar'
            classNameProp='me-5 w-100px text-center d-flex justify-content-center'
          />
          <Button
            typeBtn='button'
            label='Limpiar'
            classNameProp=' w-100px text-center d-flex justify-content-center'
          />
        </div>
      </div>
      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      <TableAvailabilityWrapper />
    </div>
  )
}

export {FormAvailability}
